<template>
  <div class="flex flex-wrap">
    <div
      v-for="asset in assets"
      :key="`image-value-${asset.id}`"
      class="mb-16 relative h-auto w-[100px] mr-16"
    >
      <img :src="asset.url.replace('http://', 'https://')">
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Asset } from '@/constants/types';

defineProps<{
  assets: Asset[];
}>();
</script>
